import { RoutingConfig } from '@app/routing/routing.config';
import { Routes } from '@angular/router';
import { NewsListsComponent } from './news-lists/news-lists.component';
import { NewsDetailComponent } from './news-detail/news-detail.component';
import { NewsCrudComponent } from './news-crud/news-crud.component';
import { NewsSeoParams } from '@app/modules/news-modules/news.seo';

export const NewsRoutes: Routes = [
  { 
    path: '',
    component: NewsListsComponent,
    data: {
      SEO: NewsSeoParams
    }
  },
  {
    path: RoutingConfig.NewsCreate,
    component: NewsCrudComponent,
    data: {
      SEO: NewsSeoParams
    }
  },
  {
    path: RoutingConfig.NewsEdit + '/:id',
    component: NewsCrudComponent,
    data: {
      SEO: NewsSeoParams
    }
  },
  {
    path: ':id',
    component: NewsDetailComponent,
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
